import TagManager from 'react-gtm-module';

export type AnalyticsProps = {
  id: string;
};

export const initialize = ({ id }: AnalyticsProps) => {
  TagManager.initialize({
    gtmId: id,
  });
};
